import { useDefaultPortfollioRoute } from '@unistocks/features/portfolios/use-route';
import { Redirect } from 'expo-router';

export default function PortfoliosScreen() {
  const href = useDefaultPortfollioRoute();

  return <Redirect withAnchor href={href} />;
}
